// extracted by mini-css-extract-plugin
module.exports = {"box":"box-1VWwpaEU","titleBox":"titleBox-b3cd_cHL","qr_pic":"qr_pic-molOVnDE"};